/**
 * * Перечень событий
 */
export enum ActionEnum {
  /**
   * * Изменение статуса
   */
  UpdateStatus = 0,
  /**
   * * Изменение приоритета
   */
  UpdatePriority = 1,
  /**
   * * Изменение типа
   */
  UpdateType = 2,
  /**
   * * Изменение уровня сложности
   */
  UpdateDifficulty = 3,
  /**
   * * Создание задачи
   */
  CreateTask = 4,
  /**
   * * Добавление тега
   */
  AttachTag = 5,
  /**
   * * Добавление файла
   */
  AttachFile = 6,
  /**
   * * Добавление исполнителя
   */
  AddPerformer = 7,
  /**
   * * Добавление наблюдателя
   */
  AddObserver = 8,
  /**
   * * Добавление подзадачи
   */
  AttachSubtask = 9,
  /**
   * * Изменение дедлайна
   */
  UpdateDateEnd = 10,
  /**
   * * Изменение названия задачи
   */
  UpdateName = 11,
  /**
   * * Удаление подзадачи
   */
  RemoveSubtask = 12,
  /**
   * * Удаление файла
   */
  RemoveFile = 13,
  /**
   * * Удаление исполнителя
   */
  RemovePerformer = 14,
  /**
   * * Удаление наблюдателя
   */
  RemoveObserver = 15,
  /**
   * * Удаление тега
   */
  RemoveTag = 16,
  /**
   * * Обновление описания
   */
  UpdateDescription = 17,
  /**
   * * Установка родителя
   */
  SetParent = 18,
  /**
   * * Удаление родителя
   */
  RemoveParent = 19,
  /**
   * * Добавление комментария
   */
  AddComment = 20,
  /**
   * * Удаление комментария
   */
  RemoveComment = 21,
  /**
   * * Успешное копирование
   */
  CopyTask = 22,
  /**
   * * Перемещение
   */
  MoveTask = 23,
  /**
   * * Обновление дочерних задач вслед за родительской
   */
  UpdateSubTaskStatus = 24,
}
